import { useSelector } from "react-redux";
import emailjs from "emailjs-com";
import React, { useState, useEffect, useCallback } from "react";
import classes from "./SendMail.module.css";

import Loader from "react-loader-spinner";

import CountdownRedirect from "./CountdownRedirect";

const {
  REACT_APP_EMAILJS_SERVICE_ID,
  REACT_APP_EMAILJS_TEMPLATE_ID,
  REACT_APP_EMAILJS_USER_ID,
} = process.env;

const SendEmail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [sendStatus, setSendStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  //form the form state
  const firstName = useSelector((state) => state.form.firstName);
  const lastName = useSelector((state) => state.form.lastName);
  const email = useSelector((state) => state.form.email);
  const phone = useSelector((state) => state.form.phone);
  let country = useSelector((state) => state.form.country);
  country = phone ? `${country} (${phone})` : country;
  const additionalRequest = useSelector(
    (state) => state.form.additionalRequest
  );

  // //from the quote state
  const airportPickUp = useSelector((state) => state.quote.airportPickUp);
  const airportDropOff = useSelector((state) => state.quote.airportDropOff);
  const extraBed = useSelector((state) => state.quote.extraBed);
  const accomPref = useSelector((state) => state.quote.accomPref);
  const promotionName = useSelector((state) => state.quote.promotionName);
  const wellnessPackageCost = useSelector(
    (state) => state.quote.wellnessPackageCost
  );
  const totalDiscount = useSelector((state) => state.quote.totalDiscount);
  const returningDiscount = useSelector(
    (state) => state.quote.returningDiscount
  );
  const transferCost = useSelector((state) => state.quote.transferCost);
  const grandTotal = useSelector((state) => state.quote.grandTotal);

  // //from the booking state
  const checkInDate = useSelector((state) => state.booking.checkInDate);
  const checkOutDate = useSelector((state) => state.booking.checkOutDate);
  const accommNights = useSelector((state) => state.booking.accommNights);
  const programDays = useSelector((state) => state.booking.programDays);
  const totalRooms = useSelector((state) => state.booking.totalRooms);
  const totalGuests = useSelector((state) => state.booking.totalGuests);
  const guest1Returning = useSelector((state) => state.booking.guest1Returning);
  const guest1ReturningEmail = useSelector(
    (state) => state.booking.guest1ReturningEmail
  );
  const guest2Returning = useSelector((state) => state.booking.guest2Returning);
  const guest2ReturningEmail = useSelector(
    (state) => state.booking.guest2ReturningEmail
  );

  const getName = useCallback(() => {
    return `Guest Name: ${firstName} ${lastName}`;
  }, [firstName, lastName]);

  const getEmail = useCallback(() => {
    return `${email}`;
  }, [email]);

  const getDepartureCountry = useCallback(() => {
    return `Departure Country: ${country}`;
  }, [country]);

  const getTravelDates = useCallback(() => {
    return `Travel Dates: ${checkInDate} (Check In) - ${checkOutDate} (Check Out) `;
  }, [checkInDate, checkOutDate]);

  const getAccommodation = useCallback(() => {
    return `Accommodation (${totalRooms} Room): ${accommNights} Nights Accommodation ${
      extraBed ? "(EXTRA BED REQUESTED)" : ""
    }`;
  }, [totalRooms, accommNights, extraBed]);

  const getProgram = useCallback(() => {
    return `Program (${totalGuests} Guest): ${programDays} Days Wellness Program`;
  }, [totalGuests, programDays]);

  const getReturning = useCallback(() => {
    return `Returning Guest: Guest 1 (${
      guest1Returning ? "Returning " + guest1ReturningEmail : "First Time"
    }) ${
      totalGuests > 1
        ? `Guest 2 (${
            guest2Returning ? "Returning " + guest2ReturningEmail : "First Time"
          })`
        : ""
    }`;
  }, [
    guest1Returning,
    totalGuests,
    guest2Returning,
    guest1ReturningEmail,
    guest2ReturningEmail,
  ]);

  const getAirportPickup = useCallback(() => {
    return `Airport Pickup: ${airportPickUp ? "Requested" : "Not Requested"}`;
  }, [airportPickUp]);

  const getDropOff = useCallback(() => {
    return `Airport Dropoff: ${airportDropOff ? "Requested" : "Not Requested"}`;
  }, [airportDropOff]);

  const getAccomPref = useCallback(() => {
    let preference = "No Preference";
    if (accomPref === "ground") {
      preference = "Ground Floor";
    }
    if (accomPref === "first") {
      preference = "First Floor";
    }
    if (accomPref === "bamboo") {
      preference = "Bamboo Room";
    }

    return `Accommodation Preference: ${preference}`;
  }, [accomPref]);

  const getQuote = useCallback(() => {
    const wellnessPackage = `${wellnessPackageCost} THB Wellness Package (Accommodation + Wellness Program)`;
    const totalDiscountApplied = `-${totalDiscount} THB ${promotionName}`;
    const returningDiscountApplied = returningDiscount
      ? `-${returningDiscount} THB Returning Discount`
      : "";
    const airportTransferCost = `${transferCost} THB Airport Transfers`;
    const quoteTotal = `${grandTotal} THB Total Quotation`;

    return {
      wellnessPackage,
      totalDiscountApplied,
      returningDiscountApplied,
      airportTransferCost,
      quoteTotal,
    };
  }, [
    wellnessPackageCost,
    totalDiscount,
    returningDiscount,
    transferCost,
    promotionName,
    grandTotal,
  ]);

  const GetAdditionalRequest = useCallback(() => {
    return `Additional Request: ${additionalRequest}`;
  }, [additionalRequest]);

  useEffect(() => {
    const guestName = getName();
    const guestEmail = getEmail();
    const departureCountry = getDepartureCountry();
    const travelDates = getTravelDates();
    const accommodation = getAccommodation();
    const program = getProgram();
    const returning = getReturning();
    const pickup = getAirportPickup();
    const dropoff = getDropOff();
    const additionalRequest = GetAdditionalRequest();
    const accommodationPref = getAccomPref();
    const {
      wellnessPackage,
      totalDiscountApplied,
      returningDiscountApplied,
      specialDiscountApplied,
      airportTransferCost,
      quoteTotal,
    } = getQuote();

    const templateParams = {
      guestname: guestName,
      email: guestEmail,
      departureCountry: departureCountry,
      travelDates: travelDates,
      accommodation: accommodation,
      program: program,
      returning: returning,
      pickup: pickup,
      dropoff: dropoff,
      wellnessPackage: wellnessPackage,
      totalDiscountApplied: totalDiscountApplied,
      returningDiscountApplied: returningDiscountApplied,
      specialDiscountApplied: specialDiscountApplied,
      airportTransferCost: airportTransferCost,
      quoteTotal: quoteTotal,
      additionalRequest: additionalRequest,
      accommodationPref: accommodationPref,
    };

    //console.log(templateParams)

    async function sendMail() {
      emailjs
        .send(
          REACT_APP_EMAILJS_SERVICE_ID,
          REACT_APP_EMAILJS_TEMPLATE_ID,
          templateParams,
          REACT_APP_EMAILJS_USER_ID
        )
        .then(
          function (response) {
            setSendStatus(true);
            //console.log(response.status, response.text)
            setIsLoading(false);
          },
          function (err) {
            setSendStatus(false);
            setIsLoading(false);
            console.log(err);
          }
        );
    }

    sendMail();
  }, [
    firstName,
    lastName,
    email,
    getName,
    getEmail,
    getDepartureCountry,
    getTravelDates,
    getAccommodation,
    getProgram,
    getReturning,
    getAirportPickup,
    getDropOff,
    getQuote,
    GetAdditionalRequest,
    getAccomPref,
  ]);

  // console.log(isLoading)

  const sendSuccessful = (
    <div className={classes.formContainer}>
      <div className={classes.outputContainer}>
        <div className={classes.submitSuccess}></div>
        <p className={classes.outputText}>
          Thank you, we have received your enquiry.
        </p>
        <p className={classes.outputText}>We will respond within 24 hours!</p>

        <CountdownRedirect />
      </div>
    </div>
  );

  const sendFailed = (
    <div className={classes.formContainer}>
      <div className={classes.outputContainer}>
        <div className={classes.submitFailed}></div>
        <p className={classes.outputText}>
          Sorry, there was a technical error!
        </p>
        <p className={classes.outputText}>
          Please contact us at info@amitywellness.com
        </p>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {isLoading && (
        <div className={classes.formContainer}>
          <div className={classes.spinnerContainer}>
            <Loader type="Rings" color="#00BFFF" height={80} width={80} />
          </div>
          <p className={classes.loadingText}>Sending Email ....</p>
        </div>
      )}

      {!isLoading && sendStatus && sendSuccessful}

      {!isLoading && !sendStatus && sendFailed}

      {/* {sendSuccessful} */}
    </React.Fragment>
  );
};

export default SendEmail;
